import { FILTER_FEATURE } from "api/ApiPath";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { BaseFilterListRequestModel } from "app/based/baseApiModel/baseFilterListModel/BaseFilterListRequestModel";
import { BaseFilterListResponseModel } from "app/based/baseApiModel/baseFilterListModel/BaseFilterListResponseModel";
import { BaseUserRequestModel } from "app/based/baseApiModel/baseUserModel/BaseUserRequestModel";
import { BaseUserResponseModel } from "app/based/baseApiModel/baseUserModel/BaseUserResponseModel";
import { FilterInjection } from "app/filters/di/FilterInjection";
import { FilterUseCase } from "app/filters/domain/useCase/FilterUseCase";
import { MobiSimRegistrationRequestModel } from "features/mobiSimRegistration/data/model/MobiSimRegistrationRequestModel";
import { MobiSimRegistrationResponseModel } from "features/mobiSimRegistration/data/model/MobiSimRegistrationResponseModel";
import { MobiSimRegistrationInjection } from "features/mobiSimRegistration/di/MobiSimRegistrationInjection";
import { IMobiSimRegistrationRepository } from "features/mobiSimRegistration/domain/repositories/IMobiSimRegistrationRepository";
import { injectable } from "tsyringe";

@injectable()
export class MobiSimRegistrationUseCase {
  private mobiSimRegistrationRepo: IMobiSimRegistrationRepository;
  private filterUseCase: FilterUseCase;

  constructor() {
    this.mobiSimRegistrationRepo =
      MobiSimRegistrationInjection.getMobiSimRegistrationRepo();
    this.filterUseCase = FilterInjection.getUseCase();
  }

  async getList(
    params: MobiSimRegistrationRequestModel,
  ): Promise<ListBaseApiResponseModel<MobiSimRegistrationResponseModel>> {
    return await this.mobiSimRegistrationRepo.getList(params);
  }

  async getDetail(
    params: MobiSimRegistrationRequestModel,
  ): Promise<BaseApiResponseModel<MobiSimRegistrationResponseModel>> {
    return await this.mobiSimRegistrationRepo.getDetail(params);
  }

  async exportReport(
    params: MobiSimRegistrationRequestModel,
  ): Promise<BaseApiResponseModel<Blob>> {
    return await this.mobiSimRegistrationRepo.exportReport(params);
  }

  async checkStatus(
    code: string,
  ): Promise<BaseApiResponseModel<MobiSimRegistrationResponseModel>> {
    return await this.mobiSimRegistrationRepo.checkStatus(code);
  }

  async getFilterList(
    params: BaseFilterListRequestModel,
    target: "carrier" | "partner" | "store" | "denomination" | "package",
  ): Promise<Array<BaseFilterListResponseModel>> {
    let path = "";
    switch (target) {
      case "carrier":
        path = FILTER_FEATURE.CARRIER_LIST;
        break;
      case "partner":
        path = FILTER_FEATURE.PARTNER_LIST;
        break;
      case "store":
        path = FILTER_FEATURE.STORE_LIST;
        break;
      case "denomination":
        path = FILTER_FEATURE.DENOMINATION_LIST;
        break;
      case "package":
        path = FILTER_FEATURE.PACKAGE_LIST;
        break;
    }
    return await this.filterUseCase.fetchListWithFeature({
      path,
      params,
      isNeedFeature: true,
    });
  }

  async getUserForFilter(
    params: BaseUserRequestModel,
    target: "staff" | "userB2B",
  ): Promise<Array<BaseUserResponseModel>> {
    let path = "";
    switch (target) {
      case "staff":
        path = FILTER_FEATURE.STAFF_LIST;
        break;
      case "userB2B":
        path = FILTER_FEATURE.USER_LIST_B2B;
        break;
    }
    return await this.filterUseCase.fetchListWithFeature({
      path,
      params,
      isNeedFeature: true,
    });
  }
}
